import { FC } from "react";
import { Avatar, StatusBadge } from "components/core";
import { displayUserName, wrapImage } from "utils";
import _ from 'lodash'
import moment from "moment";

interface SuspectedIllegalityViewProps {
  suspectedIllegality: any;
}

export const SuspectedIllegalityView: FC<SuspectedIllegalityViewProps> = ({ suspectedIllegality }) => {
  return (
    <div className="space-y-6 divide-y divide-gray-200">
      <div>
        <span className="text-xs font-light">Illegality Details</span>
        <div className="grid grid-cols-3 gap-6 mt-2">
          <div>
            <span className="block text-sm font-light text-gray-700">Code</span>
            <div className="mt-1 block w-full sm:text-sm">
              {suspectedIllegality?.code || "N/A"}
            </div>
          </div>
          <div>
            <span className="block text-sm font-light text-gray-700">Origin</span>
            <div className="mt-1 block w-full sm:text-sm">
              {suspectedIllegality?.origin ? _.startCase(suspectedIllegality?.origin) : "N/A"}
            </div>
          </div>
          <div>
            <span className="block text-sm font-light text-gray-700">Source</span>
            <div className="mt-1 block w-full sm:text-sm">
              {suspectedIllegality?.source
                ? suspectedIllegality?.source === 'IPSConsole'
                  ? "IPS Console"
                  : _.startCase(suspectedIllegality?.source)
                : "N/A"}
            </div>
          </div>
          <div>
            <span className="block text-sm font-light text-gray-700">
              Status
            </span>
            <div className="mt-1 block w-full sm:text-sm">
              {suspectedIllegality?.status ? (
                <>
                  <StatusBadge
                    status={suspectedIllegality?.status}
                    options={{
                      Pending: "bg-gray-100 text-gray-800",
                      NoticeGenerated: "bg-orange-100 text-orange-800",
                      Cancelled: "bg-red-100 text-red-800",
                      Completed: "bg-green-100 text-green-800",
                    }}
                  />
                </>
              ) : "N/A"}
            </div>
          </div>
          {
            suspectedIllegality.status === 'Cancelled' && (
              <>
                <div >
                  <span className="block text-sm font-light text-gray-700">
                    Date Cancelled
                  </span>
                  <div className="mt-1 block w-full sm:text-sm">
                    { suspectedIllegality?.cancelledAt ? moment(suspectedIllegality?.cancelledAt).format("DD/MM/YY [at] HH:mm A") : "N/A"}
                  </div>
                </div>
              </>
            )
          }
          {
            suspectedIllegality.status === 'OrderGenerated' && (
              <>
                <div >
                  <span className="block text-sm font-light text-gray-700">
                    Illegality Conf. Order Code
                  </span>
                  <div className="mt-1 block w-full sm:text-sm">
                    { suspectedIllegality?.illegalityConfirmationServiceOrderCode || "N/A"}
                  </div>
                </div> <div >
                  <span className="block text-sm font-light text-gray-700">
                    Date Order Generated
                  </span>
                <div className="mt-1 block w-full sm:text-sm">
                  { suspectedIllegality?.illegalityConfirmationServiceOrderGeneratedAt ? moment(suspectedIllegality?.illegalityConfirmationServiceOrderGeneratedAt).format("DD/MM/YY [at] HH:mm A") : "N/A"}
                </div>
              </div>
              </>
            )
          }
        </div>
      </div>
      <div className="pt-6">
        <span className="text-xs font-light">Suspected Culprit Information</span>
        <div className="grid grid-cols-3 gap-6 mt-2">
          <div className="row-span-2 flex flex-col space-y-3 items-center justify-center">
            <Avatar
              alt={
                suspectedIllegality?.suspectedCulprit?.fullName || "N A"
              }
              src={""}
              size="xl"
            />
          </div>
          <div>
            <span className="block text-sm font-light text-gray-700">
              Full Name
            </span>
            <div className="mt-1 block w-full sm:text-sm">
              {suspectedIllegality?.suspectedCulprit?.fullName || "N/A"}
            </div>
          </div>
          <div>
            <span className="block text-sm font-light text-gray-700">
              Phone Number
            </span>
            <div className="mt-1 block w-full sm:text-sm">
              {suspectedIllegality?.suspectedCulprit?.phoneNumber|| "N/A"}
            </div>
          </div>
          <div className="col-start-2 col-span-2">
            <span className="block text-sm font-light text-gray-700">
              Email Address
            </span>
            <div className="mt-1 block w-full sm:text-sm">
              {suspectedIllegality?.suspectedCulprit?.emailAddress ||
                "N/A"}
            </div>
          </div>
        </div>
      </div>
      <div className="pt-6">
        <span className="text-xs font-light">Location Information</span>
        <div className="grid grid-cols-2 gap-6 mt-2">
          <div>
            <span className="block text-sm font-light text-gray-700">
              Region
            </span>
            <div className="mt-1 block w-full sm:text-sm">
              {suspectedIllegality?.region?.name || "N/A"}
            </div>
          </div>
          <div>
            <span className="block text-sm font-light text-gray-700">
              District
            </span>
            <div className="mt-1 block w-full sm:text-sm">
              {suspectedIllegality?.district?.name || "N/A"}
            </div>
          </div>
          <div className="col-span-2">
            <span className="block text-sm font-light text-gray-700">
              GhanaPost Address
            </span>
            <div className="mt-1 block w-full sm:text-sm">
              {suspectedIllegality?.ghanaPostAddress || "N/A"}
            </div>
          </div>
          <div>
            <span className="block text-sm font-light text-gray-700">
              Address
            </span>
            <div className="mt-1 block w-full sm:text-sm">
              {suspectedIllegality?.location?.address || "N/A"}
            </div>
          </div>
          <div>
            <span className="block text-sm font-light text-gray-700">
              Community
            </span>
            <div className="mt-1 block w-full sm:text-sm">
              {suspectedIllegality?.location?.community || "N/A"}
            </div>
          </div>
        </div>
      </div>

      {
        ["TipOff", "FieldOperations"].includes(suspectedIllegality.origin) &&
          <>
              <div className="pt-6">
                  <span className="text-xs font-light">Reporter Information</span>
                  <div className="grid grid-cols-2 gap-6 mt-2">
                      <div className="col-span-2">
                <span className="block text-sm font-light text-gray-700">
                  Full Name
                </span>
                          <div className="mt-1 block w-full sm:text-sm">
                            {suspectedIllegality?.reportedBy?.fullName || "N/A"}
                          </div>
                      </div>
                      <div>
                <span className="block text-sm font-light text-gray-700">
                  Phone Number
                </span>
                          <div className="mt-1 block w-full sm:text-sm">
                            {suspectedIllegality?.reportedBy?.phoneNumber || "N/A"}
                          </div>
                      </div>
                      <div>
                <span className="block text-sm font-light text-gray-700">
                  Email Address
                </span>
                          <div className="mt-1 block w-full sm:text-sm">
                            {suspectedIllegality?.reportedBy?.emailAddress || "N/A"}
                          </div>
                      </div>
                  </div>
              </div>
          </>
      }

      <div className="pt-6">
        <span className="text-xs font-light">Extra Information</span>
        <div className="grid grid-cols-2 gap-6 mt-2">
          <div className="col-span-2">
            <span className="block text-sm font-light text-gray-700">
              Supporting Images
            </span>
            {suspectedIllegality?.supportingImageUrls?.length ? (
              <div className='mt-1 grid grid-cols-3 gap-3'>
                {suspectedIllegality?.supportingImageUrls?.map((image: string) =>
                  wrapImage(
                    <img
                      src={image}
                      alt={"back"}
                      className='w-full h-56 text-xs object-cover object-center rounded'
                    />
                  )
                )}
              </div>
            ) : (
              <div className='border-2 border-dashed border-gray-300 rounded-md mt-2 h-64 items-center justify-center flex text-gray-600'>
                Images not provided
              </div>
            )}
          </div>
          <div className="col-start-1 col-span-2">
            <span className="block text-sm font-light text-gray-700">
              Notes
            </span>
            <div className="mt-1 block w-full sm:text-sm">
              {suspectedIllegality?.notes || "N/A"}
            </div>
          </div>
        </div>
      </div>

      {
        suspectedIllegality.status === 'Cancelled' && (
          <>
            <div className="pt-6">
              <span className="text-xs font-light">Cancellation Information</span>
              <div className="grid grid-cols-2 gap-6 mt-2">
                <div className="col-span-1">
                  <span className="block text-sm font-light text-gray-700">
                    Cancelled By
                  </span>
                  <div className="mt-1 block w-full sm:text-sm">
                    {displayUserName(suspectedIllegality?.cancelledBy) || "N/A"}
                  </div>
                </div>
                <div>
                  <span className="block text-sm font-light text-gray-700">
                    Date Cancelled
                  </span>
                  <div className="mt-1 block w-full sm:text-sm">
                    { suspectedIllegality?.cancelledAt ? moment(suspectedIllegality?.cancelledAt).format("DD/MM/YY [at] HH:mm A") : "N/A"}
                  </div>
                </div>
                <div className="col-span-2">
                  <span className="block text-sm font-light text-gray-700">
                    Cancellation Reason
                  </span>
                  <div className="mt-1 block w-full sm:text-sm">
                    {suspectedIllegality?.cancellationReason || "N/A"}
                  </div>
                </div>
              </div>
            </div>
          </>
        )
      }

      <div className="pt-6">
        <span className="text-xs font-light">Created By</span>
        <div className="grid grid-cols-2 gap-6 mt-2">
          <div className="col-span-2">
            <span className="block text-sm font-light text-gray-700">
              Full Name
            </span>
            <div className="mt-1 block w-full sm:text-sm">
              {displayUserName(suspectedIllegality?.createdBy) || "N/A"}
            </div>
          </div>
          <div>
            <span className="block text-sm font-light text-gray-700">
              Phone Number
            </span>
            <div className="mt-1 block w-full sm:text-sm">
              {suspectedIllegality?.createdBy?.phoneNumber || "N/A"}
            </div>
          </div>
          <div>
            <span className="block text-sm font-light text-gray-700">
              Email Address
            </span>
            <div className="mt-1 block w-full sm:text-sm">
              {suspectedIllegality?.createdBy?.emailAddress || "N/A"}
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default SuspectedIllegalityView;
